module.exports = __webpack_public_path__ + "img/banner05.7c26821c.png";